import { Check, Clear } from '@mui/icons-material';
import { Avatar, Card, Grid2, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { type FC, type MouseEvent, useState } from 'react';

import type { TemperatureFullData } from '../../models';

interface AvaniTempCardProps {
  id: number;
  temp: TemperatureFullData;
  noPopover?: boolean;
  sx?: any;
  onClick?: () => void;
}

const AvaniStyledTempCard = styled(Card)(
  ({ theme }) => `
  border-radius: 16px;
  padding: 16px 0;

  &.AvaniCardSmall {
    padding: 16px 0 8px 0;
  }

  .MuiTypography-root.MuiTypography-h4 {
    margin: 0 16px;
    line-height: 1;
    font-size: 20px;
  }

  .MuiTypography-root.MuiTypography-h4.AvaniCardTitleTemp {
    color: ${theme.colors.avani.magenta}
  }
`
);

export const AvaniTempCard: FC<AvaniTempCardProps> = ({ temp, id, noPopover, onClick, sx }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    if (!noPopover) {
      setOpen(true);
    } else if (onClick) {
      onClick();
    }
  };

  const aid = open ? 'simple-popover' : undefined;

  const tempValue =
    typeof temp.value === 'boolean' && !!temp.value ? (
      <Check sx={{ fontSize: 22 }} />
    ) : typeof temp.value === 'number' ? (
      `${temp.value}°C`
    ) : (
      <Clear sx={{ fontSize: 22 }} />
    );

  return (
    <span>
      <AvaniStyledTempCard
        raised={true}
        id={id.toString()}
        sx={{
          height: '120px',
          backgroundColor: temp.isOor ? theme.colors.avani.lightMagenta : theme.colors.avani.lightTurc,
          ...sx
        }}
        aria-describedby={aid}
        onClick={handleClick}
      >
        <Grid2
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 1
          }}
        >
          <Typography variant="h4" color={theme.colors.avani.teal} className={temp.isOor ? 'AvaniCardTitleTemp' : ''}>
            {temp.title}
          </Typography>
          <Avatar
            sx={{
              display: 'inline-flex',
              bgcolor: temp.isOor ? theme.colors.avani.magenta : theme.colors.avani.teal,
              width: 30,
              height: 30,
              borderRadius: '50%',
              paddingTop: typeof temp.value === 'boolean' ? 0 : '3px',
              float: 'right',
              marginRight: 2
            }}
          >
            {tempValue}
          </Avatar>
        </Grid2>
        <Typography variant="body2" fontSize={12} sx={{ px: 2, flexGrow: 1 }}>
          {temp.desc}
        </Typography>
      </AvaniStyledTempCard>
    </span>
  );
};
